import { startOfMonth } from "date-fns";
import { GetSomeAbonosPasarelaParams } from "../params/GetSomeAbonosPasarelaParams";

const today = new Date();

export const filtrosAbonosPasarela: GetSomeAbonosPasarelaParams = {
   cliente: null,
   fechaIni: startOfMonth(today),
   fechaFin: today,
   estado: null
};

export const estadosIniciales = [
   { label: "ANULADO", value: "ANULADO" },
   { label: "FALLIDO", value: "FALLIDO" },
   { label: "PAGADO", value: "PAGADO" },
   { label: "PENDIENTE", value: "PENDIENTE" }
]